import React, {useEffect,useContext,useState} from 'react';
import { DataContext } from 'contexts/DataContext';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import EditableGrid from 'components/EditableGrid/EditableGrid';
import Typography from '@mui/material/Typography';
import AssessessmentIcon from '@mui/icons-material/Assessment';
import { getScore } from 'pages/Assessment/api';
import { getColumns } from './api';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';

function Score() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const [columns, setColumns] = useState([] as GridColDef[]);
  
  useEffect(() => {
    dataContext.changeShowLoader(true);
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;
    if(!dataContext.currentAssessment) return;

    getColumns(dataContext.language).then((response:any) => {
      setColumns(response);
      dataContext.changeShowLoader(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext.loading,dataContext.currentOrganization,dataContext.currentAssessment,dataContext.language]);
 
  
  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
    title={<><Typography variant='pageTitle'>{t('Eagle view')}</Typography></>}>
      {dataContext.currentAssessment && 
      <EditableGrid
        showGridToolbar={true}
        key={dataContext.currentAssessment} 
        editControls={false}
        columns={columns} 
        get={getScore}
        name='scoreGrid'
        />
         }
         <></>
    </AppLayout>
  );
}

export default Score;
